export default __webpack_public_path__ + "static/media/Background.e3d864ed.svg";